import { css } from '@emotion/react';
import React, { forwardRef, ReactNode } from 'react';
import { theme } from 'styles/theme';

type TypeInput = {
	placeholder?: string;
	width?: number;
	name?: string;
	onChange: (value: any) => void;
	onBlur?: (value: any) => void;
	error?: boolean;
	isNumber?: boolean;
	isPassword?: boolean;
	icon?: ReactNode;
	sizeMedium?: boolean;

	underline?: boolean;
	autofocus?: boolean;

	alignRight?: boolean;

	textCenter?: boolean;
};

export const Input = forwardRef<HTMLInputElement, TypeInput>(
	(
		{
			placeholder,
			width,
			onChange,
			onBlur,
			name,
			error,
			isNumber,
			isPassword,
			icon,
			sizeMedium,
			underline,
			autofocus,
			alignRight,
			textCenter,
		},
		ref,
	) => {
		// console.log(error);

		return (
			<div
				css={css`
					width: 100%;
					position: relative;

					${alignRight &&
					css`
						text-align: right;
					`}
				`}
			>
				{!!icon && (
					<div
						onClick={(e) => {
							e.preventDefault();
						}}
						css={css`
							position: absolute;
							width: 20px;
							height: 20px;
							line-height: 20px;

							color: ${theme.color.text['300']};

							top: 11px;
							left: 12px;

							${sizeMedium &&
							css`
								top: 7px;
							`}
						`}
					>
						{icon}
					</div>
				)}

				<input
					ref={ref}
					name={name}
					onChange={onChange}
					onBlur={onBlur}
					id={name}
					type={isNumber ? 'number' : isPassword ? 'password' : 'text'}
					step={isNumber ? 'any' : undefined}
					placeholder={placeholder}
					autoFocus={autofocus}
					css={css`
						height: ${sizeMedium ? 36 : 44}px;

						${textCenter &&
						css`
							text-align: center;
						`}

						${underline
							? css`
									border: 0;
									border-bottom: 1px solid #eee;
									border-radius: 0;

									&:focus {
										outline: none;
									}
							  `
							: css`
									border: 1px solid #d4d5de;
									border-radius: 8px;
							  `}

						width: ${width ? width + 'px' : '100%'};
						padding: 12px;
						font-size: 14px;
						line-height: 20px;

						&:focus {
							outline: none;
							box-shadow: 0 0 0 2px ${theme.color.primary['400']};
							border-color: transparent;
						}

						${!!icon &&
						css`
							padding-left: 44px;

							${sizeMedium &&
							css`
								padding-left: 36px;
							`}
						`}

						::placeholder {
							color: #8c8fa6;
						}

						${!!error &&
						css`
							border-color: #ff6767;
						`}
					`}
				/>
			</div>
		);
	},
);
